import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { H2, LI, P, UL } from "../../components/PolicyPage";

export default function Returns() {
  return (
    <PolicyPage
      slug="returns-refunds"
      title="Returns & Refunds"
      updated="June 2026"
      seoDescription="NQ Springs & 4x4 Accessories returns and refunds policy: surplus stock is final sale, with full Australian Consumer Law rights for faulty, incorrect or not-as-described items."
      intro="Surplus and clearance stock is sold at cost price and is final sale - but your rights under the Australian Consumer Law are never affected."
    >
      <section>
        <H2>The short version</H2>
        <UL>
          <LI>Clearance and surplus items are <strong>final sale</strong> - no returns for change of mind, wrong choice, or "it didn't suit the build".</LI>
          <LI>Checking that a part fits your vehicle is your responsibility. Ask us first and we will check it for you, free.</LI>
          <LI>If an item arrives faulty, damaged, not as described, or we send the wrong thing, you are covered - contact us and we will sort it.</LI>
        </UL>
      </section>

      <section>
        <H2>Your rights under Australian Consumer Law</H2>
        <P>
          Nothing in this policy excludes, restricts or modifies the consumer guarantees in the
          Australian Consumer Law. Our goods come with guarantees that cannot be excluded. You are
          entitled to a replacement or refund for a major failure, and to compensation for any other
          reasonably foreseeable loss or damage. You are also entitled to have goods repaired or
          replaced if they fail to be of acceptable quality and the failure does not amount to a
          major failure.
        </P>
      </section>

      <section>
        <H2>Change of mind</H2>
        <P>
          We do not accept change-of-mind returns on surplus or clearance stock. These items are
          priced at what we paid for them - there is no margin to absorb restocking, card fees or
          return freight. Please read the listing carefully, and if you are unsure whether a part
          suits your vehicle, <Link to="/enquire" className="gold-text font-semibold">ask us before you buy</Link>.
        </P>
      </section>

      <section>
        <H2>Fitment is the buyer's responsibility</H2>
        <UL>
          <LI>Listings state the vehicles a part was made for where we know them. Model years, variants, factory options and previous modifications all change what fits.</LI>
          <LI>Send us your rego or VIN and we will confirm fitment before you order. That check is free and takes minutes.</LI>
          <LI>A part that fits as described but does not suit your particular build is not a fault, and is not returnable.</LI>
        </UL>
      </section>

      <section>
        <H2>Faulty, damaged or incorrect items</H2>
        <UL>
          <LI>Contact us within <strong>7 days</strong> of delivery with your order number and photos of the item and packaging.</LI>
          <LI>We will repair, replace or refund as required by law - your choice where the failure is major.</LI>
          <LI>Where the fault is ours (wrong item sent, damaged in transit, not as described) we cover return freight.</LI>
          <LI>Do not fit a part you believe is faulty. Once a part has been installed, drilled, cut, painted or modified we generally cannot assess or replace it.</LI>
        </UL>
      </section>

      <section>
        <H2>Warranty on surplus stock</H2>
        <P>
          Surplus and clearance items are sold <strong>without warranty</strong> beyond the consumer
          guarantees described above. They are new, unused stock unless the listing says otherwise,
          but they are superseded or overstocked lines and are not covered by an NQ Springs
          workmanship or product warranty. Where a manufacturer's warranty happens to still apply,
          you deal with the manufacturer directly and we will help you with proof of purchase.
        </P>
      </section>

      <section>
        <H2>How to start a return</H2>
        <UL>
          <LI>Ring the shop on <a href="tel:0747748859" className="gold-text font-semibold">(07) 4774 8859</a> or email <a href="mailto:info@nqsprings.com.au" className="gold-text font-semibold">info@nqsprings.com.au</a> before sending anything back.</LI>
          <LI>Have your order reference (NQ-XXXXXX), the item, and photos ready.</LI>
          <LI>We will give you a return authorisation and the address to send it to - 321 Ingham Rd, Garbutt QLD 4814. Unauthorised returns may be refused.</LI>
          <LI>Approved refunds are made to the original payment method within 5 business days of us receiving and assessing the item.</LI>
        </UL>
      </section>
    </PolicyPage>
  );
}
